import template from './vault.all.html';
import controller from './vault.all.controller';
import './vault.all.scss';

let vaultallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default vaultallComponent;


// WEBPACK FOOTER //
// ./client/app/components/vault/all/vault.all.component.js